import {
  INSURANCE_TYPES_ICONS_V2,
  POLICY_BUNDLE_ICON,
} from 'constants/insurance';
import { FREQUENCY } from 'constants/options';
import { PolicyStatus, POLICY_EMPLOYER_VALUE_MAP } from 'constants/policy';
import {
  convertFrequency,
  convertToMediumDate,
  getPolicyStatus,
  prettifyNumber,
} from 'helpers';
import { IEmployer, IPolicy } from 'types';
import styles from './policiesList.scss';

export const getBorderClassName = (policy) => {
  if (policy.data === 'bundle') {
    return styles.statusRenewal;
  }

  const status = getPolicyStatus(policy);
  switch (status) {
    case PolicyStatus.EXPIRED:
    case PolicyStatus.FINISH_SETUP:
    case PolicyStatus.IN_REVIEW:
    case PolicyStatus.INCOMPLETE:
    case PolicyStatus.PROCESSING:
    case PolicyStatus.RENEWING:
      return styles.statusRenewal;
    default:
      return;
  }
};

export const getPremiumValue = (
  { frequency, policyTypeId, premium, policyProviderName }: IPolicy,
  isUnfinished: boolean,
  employer: IEmployer,
) => {
  if (employer) {
    return POLICY_EMPLOYER_VALUE_MAP.premium;
  }

  if (policyTypeId === 'creditcard') {
    return 'Free';
  }

  if (isUnfinished || R.isNil(premium)) {
    return '';
  }

  if (frequency === FREQUENCY.ONE_OFF) {
    return `$${prettifyNumber(premium)}`;
  }

  // Always convert to yearly
  const policyPremium = convertFrequency(
    premium,
    frequency,
    FREQUENCY.YEARLY,
    policyProviderName,
  );
  return `$${prettifyNumber(policyPremium)}/yr`;
};

export const getFrequencyValue = (
  { frequency, policyTypeId, processed, status }: IPolicy,
  employer: IEmployer,
) => {
  if (employer) {
    return POLICY_EMPLOYER_VALUE_MAP.frequency;
  }

  if (status === PolicyStatus.ORDER_PLACED) {
    return '';
  }

  if (policyTypeId === 'creditcard') {
    return 'Ongoing';
  }
  return processed ? frequency : '';
};

export const getRenewalDateValue = (
  renewalDate: string,
  policyTypeId: string,
  processed: boolean,
  employer,
) => {
  if (employer) {
    return POLICY_EMPLOYER_VALUE_MAP.renewalDate;
  }

  if (policyTypeId === 'creditcard') {
    return 'With card';
  }
  return processed && renewalDate ? convertToMediumDate(renewalDate) : '';
};

export const getListItemImg = (employer, policy) => {
  if (employer) {
    return employer.employerLogoUrl;
  }
  if (policy.data === 'bundle') {
    return POLICY_BUNDLE_ICON;
  }
  return INSURANCE_TYPES_ICONS_V2[policy.policyType];
};
